<template>
  <main-layout :selectedMenu="'2'">
    <!-- <div class="top container">
      <div class="top-filter">
        <div class="top-tabs">
          <div class="top-tab active">{{$t('global.视频')}}</div>
          <div class="top-tab" v-on:click="GotoUrl('/exploreauth')">{{$t('global.创作者')}}</div>
          <div class="top-tab" v-on:click="GotoUrl('/exploresubject')">{{$t('global.频道')}}</div>
        </div>
        <div class="top-tab-contents">
          <div class="top-tab-content">
            <filter-table
              ref="filterTable"
              v-model="selectedFilters"
              v-on:select-changed="FilterChanged"
              v-bind:cate="filterList"
              :singleselect="true"
            ></filter-table>
          </div>
        </div>
      </div>
      <div class="filter-result">
        <span class="pre">{{$t('global.已选条件')}}</span>
        <el-button-group v-for="(item,index) in selectedFilters" :key="index">
          <el-button plain round size="mini">{{item.name}}</el-button>
          <el-button plain icon="el-icon-close" round size="mini" @click="deleteFilter(index,item)"></el-button>
        </el-button-group>
      </div>
    </div> -->
    <div class="location" v-if="locationList.length">
      <img
        class="locationImg"
        @click="gotoLocation"
        :src="JSON.parse(locationList[0].image)[0].key | imageUrl('', 2220, 200)"
        alt=""
      />
      <div class="advertisement" v-if="locationList[0].type == '2'">{{ $t("video.广告") }}</div>
    </div>
    <div class="tagsBox" v-if="tagsData.length">
      <div class="tags">
        <div class="group clearfix">
          <div class="name">{{ $t("global.分类") }}</div>
          <div class="clearfix" ref="classTagHeight">
            <ul class="groupTag clearfix">
              <li
                class="groupTagLi"
                :class="{ active: y == classIndex }"
                @click="classSubTags(tag, 1, y)"
                v-for="(tag, y) in classTags.tagEditFroms"
                :key="y"
              >
                {{ language === "zh" ? tag.name : tag.enName }}
              </li>
            </ul>
            <ul
              class="subTag clearfix"
              v-if="classSubTag.data && classSubTag.data.length"
            >
              <li
                class="subTagLi"
                v-for="(tag, y) in classSubTag.data"
                :class="{ active: y == classSubIndex }"
                @click="selectTags(classSubTag.id, tag, 1, y)"
                :key="y"
              >
                {{ language === "zh" ? tag.name : tag.enName }}
              </li>
            </ul>
          </div>
          <!-- <div v-if="classMore" class="open">
                <span v-if="classTogger" @click="classOpen(1)">
                  更多
                  <img src="/static/newSearch/icon_more_arrow_grey_hover@2x.png" alt />
                </span>
                <span v-else @click="classOpen(2)">
                  收起
                  <img src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png" alt />
                </span>
              </div>-->
        </div>
        <div class="group clearfix" :class="{ hideBottom: openTages }">
          <div class="name">{{ $t("global.行业") }}</div>
          <div class="clearfix" ref="industryTagHeight">
            <ul
              class="groupTag"
              ref="industryTagHeight1"
              :class="industryMore && industryTogger ? 'hideMore' : ''"
            >
              <li
                class="groupTagLi"
                :class="{ active: y == industryIndex }"
                @click="classSubTags(tag, 2, y)"
                v-for="(tag, y) in industryTags.tagEditFroms"
                :key="y"
              >
                {{ language === "zh" ? tag.name : tag.enName }}
              </li>
            </ul>
            <ul
              class="subTag clearfix"
              v-if="industrySubTag.data && industrySubTag.data.length"
            >
              <li
                class="subTagLi"
                :class="{ active: y == industrySubIndex }"
                v-for="(tag, y) in industrySubTag.data"
                @click="selectTags(industrySubTag.id, tag, 2, y)"
                :key="y"
              >
                {{ language === "zh" ? tag.name : tag.enName }}
              </li>
            </ul>
          </div>
          <div v-if="industryMore" class="open">
            <span v-if="industryTogger" @click="classOpen(3)">
              {{ $t("global.更多")
              }}<img
                src="/static/newSearch/icon_more_arrow_grey_hover@2x.png"
                alt
              />
            </span>
            <span v-else @click="classOpen(4)">
              {{ $t("global.收起")
              }}<img
                src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png"
                alt
              />
            </span>
          </div>
        </div>
        <div class="group clearfix">
          <div class="name">{{ $t("video.应用场景") }}</div>
          <ul
            class="groupTag"
            ref="applicationTagHeight"
            :class="applicationMore && applicationTogger ? 'hideMore' : ''"
          >
            <li
              class="groupTagLi"
              :class="{ active: y == applicationIndex }"
              @click="classSubTags(tag, 3, y)"
              v-for="(tag, y) in applicationTags.tagEditFroms"
              :key="y"
            >
              {{ language === "zh" ? tag.name : tag.enName }}
            </li>
          </ul>
          <ul
            class="subTag clearfix"
            v-if="applicationSubTag.data && applicationSubTag.data.length"
          >
            <li
              class="subTagLi"
              :class="{ active: y == applicationSubIndex }"
              v-for="(tag, y) in applicationSubTag.data"
              @click="selectTags(applicationSubTag.id, tag, 3, y)"
              :key="y"
            >
              {{ language === "zh" ? tag.name : tag.enName }}
            </li>
          </ul>
          <div v-if="applicationMore" class="open">
            <span v-if="applicationTogger" @click="applicationTogger = false">
              {{ $t("global.更多") 
              }}<img
                src="/static/newSearch/icon_more_arrow_grey_hover@2x.png"
                alt
              />
            </span>
            <span v-else @click="applicationTogger = true">
              {{ $t("global.收起") 
              }}<img
                src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png"
                alt
              />
            </span>
          </div>
        </div>
        <div class="group clearfix">
          <div class="name">{{ $t("global.热门标签") }}</div>
          <ul
            class="groupTag"
            ref="hotTagHeight"
            :class="hotMore && hotTogger ? 'hideMore' : ''"
          >
            <li
              class="groupTagLi"
              :class="{ active: y == hotIndex }"
              @click="classSubTags(tag, 4, y)"
              v-for="(tag, y) in hotTags.tagEditFroms"
              :key="y"
            >
              {{ language === "zh" ? tag.name : tag.enName }}
            </li>
          </ul>
          <ul
            class="subTag clearfix"
            v-if="hotSubTag.data && hotSubTag.data.length"
          >
            <li
              class="subTagLi"
              :class="{ active: y == hotSubIndex }"
              v-for="(tag, y) in hotSubTag.data"
              @click="selectTags(hotSubTag.id, tag, 4, y)"
              :key="y"
            >
              {{ language === "zh" ? tag.name : tag.enName }}
            </li>
          </ul>
          <div v-if="hotMore" class="open">
            <span v-if="hotTogger" @click="hotTogger = false">
              {{ $t("global.更多")
              }}<img
                src="/static/newSearch/icon_more_arrow_grey_hover@2x.png"
                alt
              />
            </span>
            <span v-else @click="hotTogger = true">
              {{ $t("global.收起")
              }}<img
                src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png"
                alt
              />
            </span>
          </div>
        </div>
        <div class="group clearfix">
          <div class="name">{{ $t("video.上传时间") }}</div>
          <ul class="groupTag" :class="hotMore && hotTogger ? 'hideMore' : ''">
            <li
              class="groupTagLi"
              :class="{ active: dateType == tag.value }"
              @click="choiceType(tag.value)"
              v-for="(tag, y) in listTime"
              :key="y"
            >
              {{ tag.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="middle container">
      <div class="orderby">
        <label
          v-bind:class="{ active: options.videoOrderBy == null }"
          v-on:click="changeOrder()"
        >
          <span
            class="orderby-icon-time"
            :class="{ 'active-time': options.videoOrderBy == null }"
          ></span
          >{{ $t("global.默认排序") }}
        </label>
        <label
          v-bind:class="{ active: options.videoOrderBy == 1 }"
          v-on:click="changeOrder(1)"
        >
          <span
            class="orderby-icon-time"
            :class="{ 'active-time': options.videoOrderBy == 1 }"
          ></span
          >{{ $t("global.最新创作") }}
        </label>
        <label
          v-bind:class="{ active: options.videoOrderBy == 2 }"
          v-on:click="changeOrder(2)"
        >
          <span
            class="orderby-icon-visit"
            :class="{ 'active-visit': options.videoOrderBy == 2 }"
          ></span
          >{{ $t("global.按浏览量") }}
        </label>
        <label
          v-bind:class="{ active: options.videoOrderBy == 3 }"
          v-on:click="changeOrder(3)"
        >
          <span
            class="orderby-icon-zan"
            :class="{ 'active-zan': options.videoOrderBy == 3 }"
          ></span
          >{{ $t("global.按点赞数") }}
        </label>
        <label
          v-bind:class="{ active: options.videoOrderBy == 4 }"
          v-on:click="changeOrder(4)"
        >
          <span
            class="orderby-icon-comment"
            :class="{ 'active-comment': options.videoOrderBy == 4 }"
          ></span
          >{{ $t("global.按评论数") }}
        </label>
      </div>
      <div class="vedio-list">
        <el-row v-if="lists.length">
          <el-col :span="6" v-for="(item, index) in lists" :key="index">
            <item
              v-if="item.domainType == 0"
              :id="item.videoId"
              :title="item.title"
              :tags="item.tagGroupInfoList"
              :url="item.url"
              :thumb="item.thumb | imageUrl('/static/moren.png', 550, 310)"
              :nickName="item.nickName"
              :avatar="item.avatar"
              :cat="item.industryTitle || item.professionTitle"
              :isRecommend="item.isRecommend"
              :userId="item.userId"
              :duration="item.duration"
            ></item>
          </el-col>
        </el-row>
        <div v-else class="noDataImg">
          <div class="noDataBox">
            <img src="/static/newSearch/video_empty@2x.png" alt />
            <p>{{ $t("search.没有匹配的视频") }}</p>
          </div>
        </div>
        <pages
          :page-size="options.pageSize"
          :page-count="1"
          :current-page.sync="options.pageIndex"
          :total="totalRecord"
          @current-page-changed="changePage"
        ></pages>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import item from "../../components/item.vue";
import pages from "../../components/pages.vue";
import FilterTable from "../../components/FilterTable.vue";

export default {
  name: "ExploreVedio",
  metaInfo() {
    return {
      title: this.$t("global.发现视频") + " | MANA",
    };
  },
  components: {
    MainLayout,
    item,
    pages,
    FilterTable,
  },
  data() {
    return {
      upTime: false,
      type: 1,
      classTags: {},
      classSubTag: {},
      industryTags: {},
      industrySubTag: {},
      applicationTags: {},
      applicationSubTag: {},
      hotTags: {},
      hotSubTag: {},
      classMore: false,
      industryMore: false,
      applicationMore: false,
      hotMore: false,
      classTogger: true,
      industryTogger: true,
      applicationTogger: true,
      hotTogger: true,
      openTages: true,
      classIndex: 0,
      classSubIndex: null,
      industryIndex: 0,
      industrySubIndex: null,
      applicationIndex: 0,
      applicationSubIndex: null,
      hotIndex: 0,
      hotSubIndex: null,
      rightScrollHeight: null,
      options: {
        pageIndex: 1,
        pageSize: 16,
        videoOrderBy: null,
        type: 1,
        keyword: "",
        searchTagForms: [],
        indexTagId: null,
        dateType: null,
      },
      totalRecord: 0,
      lists: [],
      activityCount: 0,
      articleCount: 0,
      topicCount: 0,
      userCount: 0,
      videoCount: 0,
      hotList: [],
      tagsData: [],
      searchTagForms: [],
      isShow: false,
      locationList: [],
      listTime: [
        {
          name: this.$t("global.全部"),
          value: null,
          cat: "dateType",
        },
        {
          name: this.$t("global.一天内"),
          value: 1,
          cat: "dateType",
        },
        {
          name: this.$t("global.一周内"),
          value: 2,
          cat: "dateType",
        },
        {
          name: this.$t("global.一月内"),
          value: 3,
          cat: "dateType",
        },
        {
          name: this.$t("global.一年内"),
          value: 4,
          cat: "dateType",
        },
      ],
    };
  },
  created() {
    this.init();
    this.buriedPoint(35,0)
    // var $this = this;
    // $this.filterList = [
    //   {
    //     name: this.$t("global.行 业"),
    //     list: [],
    //   },
    //   {
    //     name: this.$t("global.专 业"),
    //     list: [],
    //   },
    //   {
    //     name: this.$t("global.热 门"),
    //     list: [],
    //   },
    //   {
    //     name: this.$t("global.上 传"),
    //     list: [
    //       {
    //         name: this.$t("global.一天内"),
    //         value: 1,
    //         cat: "dateType",
    //       },
    //       {
    //         name: this.$t("global.一周内"),
    //         value: 2,
    //         cat: "dateType",
    //       },
    //       {
    //         name: this.$t("global.一月内"),
    //         value: 3,
    //         cat: "dateType",
    //       },
    //       {
    //         name: this.$t("global.一年内"),
    //         value: 4,
    //         cat: "dateType",
    //       },
    //     ],
    //   },
    //   {
    //     name: this.$t("global.类 型"),
    //     list: [
    //       {
    //         name: this.$t("global.原创"),
    //         value: 1,
    //         cat: 4,
    //       },
    //       {
    //         name: this.$t("global.非原创"),
    //         value: 2,
    //         cat: 4,
    //       },
    //     ],
    //   },
    // ];

    // //获取地址参数

    // var industryId = this.$route.query.industryId;
    // var professionId = this.$route.query.professionId;
    // var orderByType = this.$route.query.orderByType;
    // var isOriginal = this.$route.query.isOriginal;
    // var hotTag = this.$route.query.hotTag;
    // var currentPage = this.$route.query.pageIndex;
    // var pageSiz = this.$route.query.pageSize;
    // var dateType = this.$route.query.dateType;
    // this.industryId = industryId == undefined ? "" : industryId;
    // this.professionId = professionId == undefined ? "" : professionId;
    // this.orderByType = orderByType == undefined ? 0 : orderByType;
    // this.isOriginal = isOriginal == undefined ? "" : isOriginal;
    // this.hotTag = hotTag == undefined ? "" : hotTag;
    // this.pagerParam.currentPage = currentPage == undefined ? 1 : currentPage;
    // this.pagerParam.pageSiz = pageSiz == undefined ? 20 : pageSiz;
    // this.dateType = dateType == undefined ? "" : dateType;

    // let industry;
    // let profession;
    // let hot;
    // let p1 = this.$http
    //   .get("/api/common/categoryList")
    //   .then(function (response) {
    //     if (response.data.industryList) {
    //       for (var i = 0; i < response.data.industryList.length; i++) {
    //         $this.filterList[0].list.push({
    //           name: response.data.industryList[i]["title"],
    //           value: response.data.industryList[i]["categoryId"],
    //           cat: 1,
    //         });
    //       }
    //       $this.industryList = response.data.industryList;
    //       if ($this.industryId) {
    //         industry = $this.filterList[0].list.find(
    //           (n) => n.value === parseInt($this.industryId)
    //         );
    //       }
    //     }

    //     if (response.data.professionList) {
    //       for (var i = 0; i < response.data.professionList.length; i++) {
    //         $this.filterList[1].list.push({
    //           name: response.data.professionList[i]["title"],
    //           value: response.data.professionList[i]["categoryId"],
    //           cat: 2,
    //         });
    //       }
    //       if ($this.professionId) {
    //         profession = $this.filterList[1].list.find(
    //           (n) => n.value === parseInt($this.professionId)
    //         );
    //       }
    //     }
    //   });

    // let p2 = this.$http.get("/api/video/hotTags").then(function (response) {
    //   if (response.data) {
    //     for (var i = 0; i < response.data.length; i++) {
    //       $this.filterList[2].list.push({
    //         name: response.data[i].title,
    //         value: response.data[i].id,
    //         cat: 3,
    //       });
    //     }

    //     if ($this.hotTag) {
    //       hot = $this.filterList[2].list.find((n) => n.name === $this.hotTag);
    //     }
    //   }
    // });

    // let dateObj;
    // //$t('global.时间')
    // if (this.dateType != "" && this.dateType != undefined) {
    //   let dateObjA = this.filterList[3].list.filter(
    //     (obj) => obj.value == dateType
    //   );
    //   dateObj = dateObjA[0];
    //   // this.selectedFilters.push(dateObj[0]);
    // }

    // let isOriginalObj;
    // if (this.isOriginal != "" && this.isOriginal != undefined) {
    //   let isOriginalA = this.filterList[4].list.filter(
    //     (obj) => obj.value == isOriginal
    //   );
    //   isOriginalObj = isOriginalA[0];
    // }

    // Promise.all([p1, p2]).then(() => {
    //   if (industry) {
    //     this.$refs.filterTable.selectCate(industry);
    //     $this.$forceUpdate();
    //   }
    //   if (profession) {
    //     this.$refs.filterTable.selectCate(profession);
    //     $this.$forceUpdate();
    //   }

    //   if (hot) {
    //     this.$refs.filterTable.selectCate(hot);
    //     $this.$forceUpdate();
    //   }
    //   if (dateObj) {
    //     this.$refs.filterTable.selectCate(dateObj);
    //     $this.$forceUpdate();
    //   }
    //   if (isOriginalObj) {
    //     this.$refs.filterTable.selectCate(isOriginalObj);
    //     $this.$forceUpdate();
    //   }
    // });
  },
  mounted() {
    //在这里进行读取并删除
    let homeFilter = null;
    if (this.$storage != null) {
      homeFilter = this.$storage.get(
        "homeFilter",
        this.$pureData(this.selectedFilters)
      );
    }

    if (homeFilter != null) {
      this.selectedFilters = homeFilter;
      this.FilterChanged();
      this.$storage.remove("homeFilter");
    } else {
      this.selectedFilters = [];
      this.FilterChanged();
    }
  },
  methods: {
    init() {
      this.getLocation();
      // this.rightScrollHeight = null;
      this.type = this.$route.query.type || 1;
      // if (this.$route.query.id) {
      //   this.options.indexTagId = Number(this.$route.query.id);
      // }
      // console.log(this.$route.query.topGroupId)
      this.options.keyword = "";
      this.options.type = this.$route.query.type || 1;
      this.options.dateType = this.$route.query.dateType;
      this.dateType = this.$route.query.dateType;
      if (this.$route.query.videoOrderBy) {
        this.options.videoOrderBy = this.$route.query.videoOrderBy;
      } else {
        this.options.videoOrderBy = null;
      }
      this.getTags();
    },
    getLocation() {
      this.$http.get("/api/operations/list/3").then((res) => {
        if (res.code === "OK") {
          this.locationList = res.data;
          this.locationShow(this.locationList[0]);
        }
      });
    },
    locationClick(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/click", params).then((res) => {
        //运营位点击
      });
    },
    locationShow(item) {
      if (item.isFunc) {
        return;
      }
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/show", params).then((res) => {
        //运营位展示
        item.isFunc = true;
      });
    },
    gotoLocation() {
      this.locationClick(this.locationList[0]);
      this.openLocatione(this.locationList[0]);
    },
    changePage(index) {
      this.options.pageIndex = index;
      this.getList();
    },
    toggerTime() {
      this.upTime = !this.upTime;
    },
    choiceType(type) {
      this.toggerTime();
      this.$router.push({
        path: "/explorevideo",
        query: {
          type: 1,
          videoOrderBy: this.options.videoOrderBy,
          id: this.options.indexTagId,
          dateType: type,
          searchTagForms: JSON.stringify(this.options.searchTagForms),
        },
      });
    },
    getList() {
      let params = {};
      if (this.type == 1) {
        params = {
          type: this.options.type,
          pageIndex: this.options.pageIndex,
          pageSize: this.options.pageSize,
          keyword: "",
          videoOrderBy: this.options.videoOrderBy,
          searchTagForms: this.searchTagForms.length
            ? this.searchTagForms
            : this.options.searchTagForms,
          indexTagId: this.options.indexTagId,
          dateType: this.options.dateType,
        };
      } else {
        params = {
          type: this.options.type,
          pageIndex: this.options.pageIndex,
          pageSize: this.options.pageSize,
          keyword: this.options.keyword,
        };
      }
      // this.getCount(params);
      this.$http
        .post("/api/search/list2", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.lists = res.data.pageList.list;
          this.totalRecord = res.data.pageList.totalRecord;
        });
    },
    classOpen(index) {
      if (index == 1) {
        this.classTogger = false;
      }
      if (index == 2) {
        this.classTogger = true;
      }
      if (index == 3) {
        this.industryTogger = false;
      }
      if (index == 4) {
        this.industryTogger = true;
      }
      if (this.openTages) {
        this.$nextTick(() => {
          this.rightScrollHeight =
            this.$refs.classTagHeight.offsetHeight +
            this.$refs.industryTagHeight.offsetHeight;
        });
      }
    },
    stopOpen() {
      this.openTages = !this.openTages;
      if (this.openTages) {
        this.classTogger = true;
        this.industryTogger = true;
        this.applicationTogger = true;
        this.hotTogger = true;
        this.$nextTick(() => {
          this.rightScrollHeight =
            this.$refs.classTagHeight.offsetHeight +
            this.$refs.industryTagHeight.offsetHeight;
        });
      }
    },
    selectTags(id, item, type, y) {
      let topGroupId = null;
      let deteleTag = false;
      if (type == 1) {
        topGroupId = 1;
        this.classSubIndex = y;
      }
      if (type == 2) {
        topGroupId = 11;
        this.industrySubIndex = y;
      }
      if (type == 3) {
        topGroupId = 14;
        this.applicationSubIndex = y;
      }
      if (type == 4) {
        topGroupId = 15;
        this.hotSubIndex = y;
      }
      if (this.options.searchTagForms.length != 0) {
        for (let i = 0; i < this.options.searchTagForms.length; i++) {
          if (
            (this.options.searchTagForms[i].topGroupId == topGroupId &&
              this.options.searchTagForms[i].groupId == id &&
              this.options.searchTagForms[i].tagId == item.id) ||
            (this.options.searchTagForms[i].topGroupId == topGroupId && id == 0)
          ) {
            this.options.searchTagForms.splice(i, 1);
            if (type == 1) {
              this.classSubIndex = null;
              this.classIndex = 0;
              // if (id == 0) {
              //   this.classIndex = 0;
              // }
            }
            if (type == 2) {
              this.industrySubIndex = null;
              this.industryIndex = 0;
              // if (id == 0) {
              //   this.industryIndex = 0;
              // }
            }
            if (type == 3) {
              this.applicationSubIndex = null;
              this.applicationIndex = 0;
              // if (id == 0) {
              //   this.applicationIndex = 0;
              // }
            }
            if (type == 4) {
              this.hotSubIndex = null;
              this.hotIndex = 0;
              // if (id == 0) {
              //   this.hotIndex = 0;
              // }
            }
            // this.options.pageIndex = 1;
            // this.options.videoOrderBy = 0;
            // this.getList();
            this.options.indexTagId = null;
            this.$router.push({
              path: "/explorevideo",
              query: {
                type: 1,
                id: null,
                videoOrderBy: this.options.videoOrderBy,
                searchTagForms: JSON.stringify(this.options.searchTagForms),
              },
            });
            return;
          }
          if (this.options.searchTagForms[i].topGroupId == topGroupId) {
            this.options.searchTagForms.splice(i, 1);
            break;
          }
        }
      }
      this.options.searchTagForms.push({
        topGroupId: topGroupId,
        groupId: id,
        tagId: item.id,
      });
      // this.options.pageIndex = 1;
      // this.options.videoOrderBy = 0;
      // this.getList();
      this.options.indexTagId = null;
      this.$router.push({
        path: "/explorevideo",
        query: {
          type: 1,
          id: null,
          videoOrderBy: this.options.videoOrderBy,
          searchTagForms: JSON.stringify(this.options.searchTagForms),
        },
      });
    },
    classSubTags(item, index, i) {
      if (item.id == 0) {
        if (index == 1) {
          this.classSubTag = {};
          this.classIndex = i;
          this.classSubIndex = null;
        }
        if (index == 2) {
          this.industrySubTag = {};
          this.industryIndex = i;
          this.industrySubIndex = null;
        }
        if (index == 3) {
          this.applicationSubTag = {};
          this.applicationIndex = i;
          this.applicationSubIndex = null;
        }
        if (index == 4) {
          this.hotSubTag = {};
          this.hotIndex = i;
          this.hotSubIndex = null;
        }

        this.selectTags(item.id, item, index, 0);
        // if (this.openTages) {
        //   this.$nextTick(() => {
        //     this.rightScrollHeight =
        //       this.$refs.classTagHeight.offsetHeight +
        //       this.$refs.industryTagHeight.offsetHeight;
        //   });
        // }
        return;
      }
      if (item.isGroup == false) {
        if (index == 1) {
          this.classSubTag = {};
          this.classIndex = i;
          this.classSubIndex = null;
        }
        if (index == 2) {
          this.industrySubTag = {};
          this.industryIndex = i;
          this.industrySubIndex = null;
        }
        if (index == 3) {
          this.applicationSubTag = {};
          this.applicationIndex = i;
          this.applicationSubIndex = null;
        }
        if (index == 4) {
          this.hotSubTag = {};
          this.hotIndex = i;
          this.hotSubIndex = null;
        }
        this.selectTags(item.tagId, { id: item.tagId }, index, 0);
        return;
      }
      this.$http
        .get("/api/video/tag/category/child/" + item.tagId)
        .then((res) => {
          if (index == 1) {
            this.classSubTag = {};
            this.classIndex = i;
            this.classSubIndex = null;
            let data = [];
            data = res.data;
            data.unshift({
              id: 0,
              name: "全部",
              enName: "All",
            });
            this.classSubTag = {
              id: item.id,
              data: data,
            };
          }
          if (index == 2) {
            this.industrySubTag = {};
            this.industryIndex = i;
            this.industrySubIndex = null;
            let data = [];
            data = res.data;
            data.unshift({
              id: 0,
              name: "全部",
              enName: "All",
            });
            this.industrySubTag = {
              id: item.id,
              data: data,
            };
          }
          if (index == 3) {
            this.applicationSubTag = {};
            this.applicationIndex = i;
            this.applicationSubIndex = null;
            let data = [];
            data = res.data;
            data.unshift({
              id: 0,
              name: "全部",
              enName: "All",
            });
            this.applicationSubTag = {
              id: item.id,
              data: data,
            };
          }
          if (index == 4) {
            this.hotSubTag = {};
            this.hotIndex = i;
            this.hotSubIndex = null;
            let data = [];
            data = res.data;
            data.unshift({
              id: 0,
              name: "全部",
              enName: "All",
            });
            this.hotSubTag = {
              id: item.id,
              data: data,
            };
          }
          // if (this.openTages) {
          //   this.$nextTick(() => {
          //     this.rightScrollHeight =
          //       this.$refs.classTagHeight.offsetHeight +
          //       this.$refs.industryTagHeight.offsetHeight;
          //   });
          // }
          this.selectTags(item.id, { id: 0 }, index, 0);
        });
    },
    getTags() {
      this.$http.get("/api/video/tag/group/childnew").then((res) => {
        let data = res.data;
        this.tagsData = res.data;
        for (let i = 0; i < data.length; i++) {
          if (data[i].id == 1) {
            this.classTags = data[i];
          }
          if (data[i].id == 11) {
            this.industryTags = data[i];
          }
          if (data[i].id == 14) {
            this.applicationTags = data[i];
          }
          if (data[i].id == 15) {
            this.hotTags = data[i];
          }
        }
        this.classTags.tagEditFroms.unshift({
          id: 0,
          name: "全部",
          enName: "All",
        });
        this.industryTags.tagEditFroms.unshift({
          id: 0,
          name: "全部",
          enName: "All",
        });
        this.applicationTags.tagEditFroms.unshift({
          id: 0,
          name: "全部",
          enName: "All",
        });
        this.hotTags.tagEditFroms.unshift({
          id: 0,
          name: "全部",
          enName: "All",
        });

        this.$nextTick(() => {
          // if (this.$refs.classTagHeight.offsetHeight > 64) {
          //   this.classMore = true;
          // }
          setTimeout(() => {
            this.rightScrollHeight =
              this.$refs.classTagHeight.offsetHeight +
              this.$refs.industryTagHeight.offsetHeight;
          }, 50);
          if (this.$refs.industryTagHeight1.offsetHeight > 44) {
            this.industryMore = true;
          }
          if (this.$refs.applicationTagHeight.offsetHeight > 44) {
            this.applicationMore = true;
          }
          if (this.$refs.hotTagHeight.offsetHeight > 44) {
            this.hotMore = true;
          }
        });
        if (
          this.$route.query.searchTagForms &&
          this.$route.query.searchTagForms.length
        ) {
          this.searchTagForms = JSON.parse(this.$route.query.searchTagForms);
          // let tagsSearch = JSON.parse(this.$route.query.searchTagForms);
          // for (let y = 0; y < tagsSearch.length; y++) {
          //   if (tagsSearch[y].topGroupId == 1) {
          //     for (let i = 0; i < this.classTags.tagEditFroms.length; i++) {
          //       if (
          //         this.classTags.tagEditFroms[i].id == tagsSearch[y].groupId
          //       ) {
          //         this.classSubTags(this.classTags.tagEditFroms[i], 1, i, true);
          //         return;
          //       }
          //     }
          //   }
          // }
        } else if (this.$route.query.topGroupId) {
          if (this.$route.query.topGroupId == 1) {
            for (let i = 0; i < this.classTags.tagEditFroms.length; i++) {
              if (
                this.classTags.tagEditFroms[i].id == this.$route.query.groupId
              ) {
                this.classSubTags(this.classTags.tagEditFroms[i], 1, i);
                return;
              }
            }
          }
          if (this.$route.query.topGroupId == 11) {
            for (let i = 0; i < this.industryTags.tagEditFroms.length; i++) {
              if (
                this.industryTags.tagEditFroms[i].id ==
                this.$route.query.groupId
              ) {
                this.classSubTags(this.industryTags.tagEditFroms[i], 2, i);
                this.industryTogger = false;
                return;
              }
            }
          }
          if (this.$route.query.topGroupId == 14) {
            for (let i = 0; i < this.applicationTags.tagEditFroms.length; i++) {
              if (
                this.applicationTags.tagEditFroms[i].id ==
                this.$route.query.groupId
              ) {
                this.classSubTags(this.applicationTags.tagEditFroms[i], 3, i);
                this.applicationTogger = false;
                return;
              }
            }
          }
          if (this.$route.query.topGroupId == 15) {
            for (let i = 0; i < this.hotTags.tagEditFroms.length; i++) {
              if (
                this.hotTags.tagEditFroms[i].id == this.$route.query.groupId
              ) {
                this.classSubTags(this.hotTags.tagEditFroms[i], 4, i);
                this.hotTogger = false;
                return;
              }
            }
          }
        } else {
          this.options.searchTagForms = [];
        }
        this.getList();
      });
    },
    changeOrder(val) {
      // this.options.pageIndex = 1;
      // this.options.videoOrderBy = val;
      // this.getList();
      this.$router.push({
        path: "/explorevideo",
        query: {
          type: 1,
          videoOrderBy: val,
          id: this.options.indexTagId,
          dateType: this.options.dateType,
          searchTagForms: JSON.stringify(this.options.searchTagForms),
        },
      });
    },
    GoToSubjectDetail() {
      this.$router.push("/subjectdetail");
    },
    GetVideoList() {
      var selectQuery = {};

      if (this.industryId != "" && this.industryId != undefined) {
        selectQuery.industryId = this.industryId;
      }
      if (this.professionId != "" && this.professionId != undefined) {
        selectQuery.professionId = this.professionId;
      }
      if (this.orderByType != "" && this.orderByType != undefined) {
        selectQuery.orderByType = this.orderByType;
      }
      if (this.isOriginal != "" && this.isOriginal != undefined) {
        selectQuery.isOriginal = this.isOriginal;
      }
      if (this.hotTag != "" && this.hotTag != undefined) {
        selectQuery.hotTag = this.hotTag;
      }
      if (this.pageIndex != "" && this.pageIndex != undefined) {
        selectQuery.pageIndex = this.pageIndex;
      }
      if (this.pageSize != "" && this.pageSize != undefined) {
        selectQuery.pageSize = this.pageSize;
      }
      if (this.dateType != "" && this.dateType != undefined) {
        selectQuery.dateType = this.dateType;
      }
      this.$router.push({ path: "/explorevideo", query: selectQuery });

      // ------
      var $this = this;
      this.$http
        .get(
          "/api/video/findVideoList?industryId=" +
            this.industryId +
            "&professionId=" +
            this.professionId +
            "&orderByType=" +
            this.orderByType +
            "&isOriginal=" +
            this.isOriginal +
            "&hotTag=" +
            this.hotTag +
            "&pageIndex=" +
            this.pagerParam.currentPage +
            "&pageSize=" +
            this.pagerParam.pageSize +
            "&dateType=" +
            this.dateType
        )
        .then(function (response) {
          if (response.data) {
            $this.videoList = response.data.list;
            $this.pagerParam = {
              pageSize: response.data.pageSize,
              pageCount: response.data.totalPage,
              currentPage: response.data.pageIndex,
              total:
                response.data.totalRecord > 2000
                  ? 2000
                  : response.data.totalRecord,
            };
            $this.$forceUpdate();
          }
        });
    },
    GotoUrl(url) {
      this.$router.push(url);
    },
    FilterChanged() {
      // debugger
      // this.industryId = "";
      // this.professionId = "";
      // this.hotTag = "";
      // this.isOriginal = "";
      // this.pagerParam.currentPage = 1;
      // this.dateType = ""
      // console.log(this.$pureData(this.selectedFilters));
      for (var i = 0; i < this.selectedFilters.length; i++) {
        if (this.selectedFilters[i].cat == 1) {
          this.industryId = this.selectedFilters[i].value;
        } else if (this.selectedFilters[i].cat == 2) {
          this.professionId = this.selectedFilters[i].value;
        } else if (this.selectedFilters[i].cat == 3) {
          this.hotTag = this.selectedFilters[i].name;
        } else if (this.selectedFilters[i].cat == "dateType") {
          this.dateType = this.selectedFilters[i].value;
        } else {
          this.isOriginal = this.selectedFilters[i].value;
        }
      }

      this.GetVideoList();
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.GetVideoList();
    },
    deleteFilter(index, item) {
      if (item.cat == 1) {
        this.industryId = "";
      }
      if (item.cat == 2) {
        this.professionId = "";
      }
      if (item.cat == 3) {
        this.hotTag = "";
      }
      if (item.cat == "dateType") {
        this.dateType = "";
      }
      if (item.cat == 4) {
        this.isOriginal = "";
      }
      this.selectedFilters.splice(index, 1);
      this.FilterChanged();
    },
  },
  watch: {
    // orderByType: function () {
    //   this.GetVideoList();
    // },
    $route(to, from) {
      // window.location.reload();
      // this.content = this.$route.params.content;
      // this.options.keyword = this.content;
      // this.options1.keyword = this.content;
      this.init();
      this.searchTagForms = [];
    },
  },
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>

<style scoped>
.body {
  background: #fff;
}
.top {
  padding-top: 0.6rem;
}
.container {
  max-width: 1110px;
}

.container {
  width: 1110px;
  position: relative;
}

.top-filter {
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  overflow: hidden;
  zoom: 1;
}

.top-tabs {
  width: 1.4rem;
  float: left;
  font-size: 0.26rem;
}

.top-tab {
  height: 0.87rem;
  line-height: 0.87rem;
  text-align: center;
  background-color: #fbfbfb;
  cursor: pointer;
  color: #999;
}

.top-tab.active {
  background-color: #fff;
  color: #333333;
}

.top-tab-contents {
  float: left;
  width: 1040px;
  /* max-height: 2.21rem; */
}

.filter-result {
  margin-top: 0.2rem;
  text-align: center;
}

.filter-result .pre {
  margin-right: 0.4rem;
}

.filter-result .el-button {
  color: #0060ff;
  border-color: #dcdfe6 !important;
}

.filter-result .el-button-group {
  margin-right: 0.2rem;
}

.orderby {
  margin-top: 0.4rem;
  margin-bottom: 0.17rem;
  line-height: 0.16rem;
  color: #777777;
  font-size: 0.16rem;
}
.orderby > label {
  display: inline-block;
  margin-right: 0.3rem;
}
.orderby .active {
  color: #0060ff;
}

.orderby .active-time {
  background: url("/static/explore/focusTime.png") no-repeat center center;
  background-size: contain;
}

.orderby .active-visit {
  background: url("/static/explore/focusVisit.png") no-repeat center center;
  background-size: contain;
}

.orderby .active-zan {
  background: url("/static/explore/focusZan.png") no-repeat center center;
  background-size: contain;
}

.orderby .active-comment {
  background: url("/static/explore/focusComment.png") no-repeat center center;
  background-size: contain;
}

.orderby label {
  cursor: pointer;
}

.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/time.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.16rem;
  background: url("/static/explore/visit.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/zan.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/comment.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.vedio-list {
  padding-bottom: 50px;
}
.vedio-list .el-row {
  margin: 0 -15px;
}

.vedio-list .item {
  margin: 15px;
  cursor: pointer;
}

.author-item {
  overflow: hidden;
  zoom: 1;
  border-bottom: 1px solid #dddddd;
  padding: 0.4rem 0;
}

.author-info {
  float: left;
  width: 7.46rem;
  overflow: hidden;
  zoom: 1;
}

.author-avatar {
  width: 1.3rem;
  height: 1.3rem;
  float: left;
  display: block;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.author-content {
  width: 6.13rem;
  float: left;
  padding-left: 0.3rem;
  padding-top: 0.07rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.author-name {
  font-size: 0.26rem;
  color: #333333;
}

.author-title {
  font-size: 0.16rem;
  color: #777777;
  margin: 0.1rem 0 0.2rem;
}

.author-focus {
  display: block;
  width: 1.2rem;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  background-color: #0060ff;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
}

.author-vedio {
  float: right;
  width: 8.6rem;
  margin: 0.07rem -0.05rem 0;
  overflow: hidden;
  zoom: 1;
  position: relative;
}

.author-vedio-item {
  width: 25%;
  float: left;
  padding: 0 0.05rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.author-vedio-item img {
  width: 2.06rem;
  height: 1.16rem;
  display: block;
  margin: 0 auto;
}

.orderby-icon-user {
  display: inline-block;
  width: 0.16rem;
  height: 0.15rem;
  background: url("/static/explore/user.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
}

.orderby-icon-vedio {
  display: inline-block;
  width: 0.16rem;
  height: 0.14rem;
  background: url("/static/explore/vediocount.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.subject-list {
  margin: -0.13rem;
  overflow: hidden;
  zoom: 1;
}

.subject-item {
  display: block;
  float: left;
  width: 3.8rem;
  margin: 0.13rem;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;
  height: 3.73rem;
  position: relative;
  padding-bottom: 0.3rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.subject-add {
  cursor: pointer;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 2.6rem;
  text-align: center;
  font-size: 0.22rem;
  color: #333333;
}

.subject-add:before {
  content: "";
  display: block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 3.6rem;
  height: 3.53rem;
  position: absolute;
  left: 0.1rem;
  top: 0.1rem;
  border: 2px dotted #e1e1e1;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}

.subject-add:after {
  content: "";
  display: block;
  width: 0.8rem;
  height: 0.8rem;
  background: url("/static/explore/add.png") no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 1.5rem;
  top: 1.5rem;
}

.subject-img {
  display: block;
  height: 2.15rem;
  width: 3.8rem;
}

.subject-title {
  font-size: 0.22rem;
  color: #333333;
  margin: 0.2rem 0 0.1rem;
  padding: 0 0.18rem;
}

.subject-count {
  font-size: 0.14rem;
  color: #777777;
  margin: 0 0 0.2rem;
  padding: 0 0.2rem;
}

.subject-summary {
  font-size: 0.16rem;
  color: #333333;
  padding: 0 0.18rem;
}
</style>
<style lang="stylus" scoped>
.location {
  width: 1110px;
  height: 100px;
  margin: 20px auto 0;
  position: relative;

  .locationImg {
    width: 100%;
    height: 100%;
    display: inline-block;
    cursor: pointer;
  }

  .advertisement {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 4px;
    height: 16px;
    background: rgba(51, 51, 51, 0.4);
    border-radius: 0px 6px 0px 0px;
    line-height: 16px;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
  }
}

.tagsBox {
  position: relative;

  .tags {
    background: rgba(245, 245, 245, 1);
    margin: 30px auto;
    width: 1070px;
    padding: 10px 20px;
    font-size: 13px;

    .group {
      border-bottom: 1px solid #E0E0E0;
      position: relative;

      &:nth-child(5) {
        border-bottom: none;
      }

      .name {
        width: 70px;
        float: left;
        padding-top: 15px;
        color: #666;
        font-weight: 500;
      }

      .open {
        position: absolute;
        right: 0;
        top: 12px;
        cursor: pointer;

        span {
          font-size: 13px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);

          img {
            width: 20px;
            height: 20px;
            vertical-align: bottom;
          }

          &:hover {
            color: #333;
          }
        }
      }

      .groupTag {
        width: 945px;
        float: left;
        padding-bottom: 10px;

        .groupTagLi {
          float: left;
          margin-right: 36px;
          color: #333;
          font-weight: 400;
          height: 24px;
          line-height: 24px;
          margin-top: 10px;
          cursor: pointer;
          font-size: 13px;

          &:hover {
            color: #2026CC;
          }
        }

        .active {
          background: rgba(32, 38, 204, 1);
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          margin-right: 24px;
          padding: 0 10px;

          &:hover {
            color: rgba(255, 255, 255, 1);
          }
        }
      }

      .subTag {
        width: 952px;
        padding: 2px 24px 12px;
        float: left;
        margin-left: 70px;
        background: rgba(255, 255, 255, 1);
        margin-bottom: 10px;

        .subTagLi {
          float: left;
          margin-right: 36px;
          color: rgba(102, 102, 102, 1);
          font-weight: 400;
          height: 20px;
          line-height: 20px;
          margin-top: 10px;
          cursor: pointer;
        }

        .active {
          color: #2026CC;
          font-weight: 600;
        }
      }

      .hideMore {
        height: 36px;
        overflow: hidden;
      }
    }
  }

  .hideTags {
    overflow: hidden;
  }

  .openTages {
    position: absolute;
    width: 44px;
    height: 20px;
    background: rgba(245, 245, 245, 1);
    left: 50%;
    transform: translateX(-50%);
    bottom: -20px;
    text-align: center;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.noDataImg {
  width: 100%;
  padding-top: 80px;

  .noDataBox {
    width: 200px;
    margin: 0 auto;

    img {
      width: 88px;
      height: 88px;
      margin: 0 56px;
      margin-bottom: 30px;
    }

    p {
      font-size: 15px;
      font-weight: 400;
      color: rgba(184, 184, 184, 1);
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/explore/ExploreVideo.vue